// extracted by mini-css-extract-plugin
module.exports = {"topImage":"Supplier_topImage__deE9p","title":"Supplier_title__2Bj3V","image":"Supplier_image__1zrPR","gridItem":"Supplier_gridItem__EEBWG","content":"Supplier_content__1_5Xk"};